import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    padding: 24,
    fontSize: 10,
  },
  title: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 24,
  },
  table: {
    display: 'flex',
    width: 'auto',
  },
  tableRowHeader: {
    flexDirection: 'row',
    gap: '0.5rem',
    borderBottom: '1pt solid black',
    backgroundColor: '#f0f0f0',
    padding: 4,
  },
  tableRow: {
    flexDirection: 'row',
    gap: '0.5rem',
    borderBottom: '1pt solid #eee',
    padding: 4,
  },
  tableCellHeader: {
    flex: 1,
    fontSize: 11,
    textAlign: 'left',
  },
  tableCell: {
    flex: 1,
    fontSize: 8.5,
    textAlign: 'left',
  },
  subText: {
    fontSize: 8,
    color: '#666',
    marginTop: 2,
    width: '90%',
  },
  tableCellSmall: {
    flex: 0.8,
    fontSize: 8.5,
    textAlign: 'left',
  },
  tableCellHeaderSmall: {
    flex: 0.8,
    fontSize: 11,
    textAlign: 'left',
  },
  textField: {
    width: '90%',
  },
  email: {
    maxWidth: '100%',
    fontSize: 8,
    lineHeight: 1.2,
  },
});
